import { render, staticRenderFns } from "./addProduct.vue?vue&type=template&id=f74fabe8&scoped=true&"
import script from "./addProduct.vue?vue&type=script&lang=ts&name=addProduct&"
export * from "./addProduct.vue?vue&type=script&lang=ts&name=addProduct&"
import style0 from "./addProduct.vue?vue&type=style&index=0&id=f74fabe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74fabe8",
  null
  
)

export default component.exports